
export default {
    namespaced: true,
    state: {
        groups: [],
        dots: [],
        unitScale: {
            pixel: 0,
            lenght: 0,
            type: 'meter' 
        },
        controls: {
            zoom: true,
            drag: true
        },
        symbols: [],
        dragEquipId: null
    },
    actions: {
        rotate({state}, direction){
            let degree = direction == 'left' ? -10 : 10
            let section = this.getters['sections/item']
            let scale = this.getters['assets/scale']
            let group = state.groups[section.id].obj
            let center = new paper.Point(section.center_coords.x,section.center_coords.y)
            group.rotate(degree, center)
            let shape = group.children[0]
            section.coords = shape.segments.map(segment=>{
                return { x: segment.point.x * scale, y: segment.point.y * scale}
            });
            this.commit("sections/ITEM", section)
        },
    },
    mutations: {
        symbols(state, value){
            state.symbols = value
        },
        dragEquipId(state, value){
            state.dragEquipId = value
        },
        controls(state, value){
            state.controls = value
        },
        groups(state, value){
            state.groups = value
        },
        dots(state, value){
            state.dots = value
        },
        unitScale: (state, value) => {
            state.unitScale = value
        },
        'unitScale.pixel': (state, value) => {
            state.unitScale.pixel = value
        }
    },
    getters: {
        symbols: state => state.symbols,
        dragEquipId: state => state.dragEquipId,
        controls: state => state.controls,
        groups: state => state.groups,
        dots: state => state.dots,
        unitScale: (state) => state.unitScale,
    }
}